import { TableCell, TableRow, toCurrencyString, CurrencyCode } from '@client/toolkit';
import { ChangePercentage } from '../../components';
import { PremisesVacancyCostDetailsDto } from '@client/api';
import { useTranslation } from 'react-i18next';

export const PremiseRow = ({ premise }: { premise: PremisesVacancyCostDetailsDto }) => {
  const { t } = useTranslation('reporting');
  return (
    <TableRow className="bg-surface-base border-b border-surface-elevated">
      <TableCell className="px-2 py-2"></TableCell>
      <TableCell className="px-2 py-2"></TableCell>
      <TableCell className="px-2 py-2">{premise.spaceType}</TableCell>
      <TableCell className="px-2 py-2 align-top">{premise.vacantSqmDays}</TableCell>
      <TableCell className="px-2 py-2 align-top">
        {!premise.selectedYearAmount
          ? t('notAvailable')
          : toCurrencyString(premise.selectedYearAmount.value, '-', {
              currency: premise.selectedYearAmount.currency as CurrencyCode,
            })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {!premise.previousYearAmount
          ? t('notAvailable')
          : toCurrencyString(premise.previousYearAmount.value, '-', {
              currency: premise.previousYearAmount.currency as CurrencyCode,
            })}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        {premise.numberOfWeekAvailable === 0 ? `0 ${t('vacancyCost.weeks')}` : ''}
        {premise.numberOfWeekAvailable / 4 >= 1
          ? `${Math.floor(premise.numberOfWeekAvailable / 4)} ${t('vacancyCost.month')}`
          : ''}
        {premise.numberOfWeekAvailable % 4 >= 1
          ? ` ${Math.floor(premise.numberOfWeekAvailable % 4)} ${t('vacancyCost.weeks')}`
          : ''}
      </TableCell>
      <TableCell className="px-2 py-2 align-top">
        <ChangePercentage value={premise.changePercentage} size="sm" isInverted />
      </TableCell>
    </TableRow>
  );
};
